import { getConfigs } from "@api/config";
import { ConfigDTO } from "@shared/dto/ConfigDTO";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";

interface IConfigProvider {
  config?: ConfigDTO | null;
  setConfig: (config: ConfigDTO) => void;
}

const blankConfig: IConfigProvider = {
  config: null,
  setConfig: () => {}
};

export const configContext = createContext<IConfigProvider>(blankConfig);

export const ConfigProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [configs, setConfigs] = useState<ConfigDTO | null>(null);

  useEffect(() => {
    if (configs) {
      setConfigs(configs);
    } else {
      getConfigs().then(data => {
        setConfigs(data);
      });
    }
  }, [configs]);

  return (
    <configContext.Provider value={{ config: configs, setConfig: setConfigs }}>
      {children}
    </configContext.Provider>
  );
};

export const useConfigContext = () => {
  return useContext(configContext);
};
